import { Input } from '@/components/ui/input';

export const GREEN = '#0B6B55';
export const mono = { fontFamily: "'IBM Plex Mono', monospace" };

export const Card = ({ children, className = '', ...rest }) => (
  <div className={`rounded-lg border bg-white p-6 ${className}`} style={{ borderColor: '#E5E3DC' }} {...rest}>{children}</div>
);

export const Field = ({ label, value, onChange, testId, ...props }) => (
  <div>
    <label className="text-sm block mb-1" style={{ color: '#4b504a' }}>{label}</label>
    <Input data-testid={testId} value={value ?? ''} onChange={e => onChange(e.target.value)}
      className="bg-white border-[#D9D6CD]" {...props} />
  </div>
);

export const Sel = ({ label, value, onChange, options, testId, disabledOptions = [] }) => (
  <div>
    <label className="text-sm block mb-1" style={{ color: '#4b504a' }}>{label}</label>
    <select data-testid={testId} value={value ?? ''} onChange={e => onChange(e.target.value)}
      className="w-full h-9 rounded-md border px-3 text-sm bg-white" style={{ borderColor: '#D9D6CD' }}>
      <option value="">—</option>
      {options.map(([v, l]) => (
        <option key={v} value={v} disabled={disabledOptions.includes(v)}>{l}{disabledOptions.includes(v) ? ' (not allowed for BFSI)' : ''}</option>
      ))}
    </select>
  </div>
);

export const StatusPill = ({ ok, label }) => (
  <span className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full font-medium"
    style={ok ? { background: '#E3F1EC', color: GREEN } : { background: '#FBEAE5', color: '#B3401F' }}>
    {ok ? '✓' : '✗'} {label}
  </span>
);
